import { BaseControl } from "../base-control";

class TextControlCtrl extends BaseControl {
  _initialWidth = null;
  _maxWidth = null;
  constructor(BaseControlService, $scope, $sce, $window, $document, $timeout) {
    'ngInject';
    super(BaseControlService, $scope);
    Object.assign(this, { $sce, $window, $document, $timeout });
  }

  get initialWidth() {
    if (this._initialWidth === null) this._initialWidth = $(`.token-id-${this.token.id}.text-control`).width();
    return this._initialWidth;
  }

  get maxWidth() {
    if (this._maxWidth == null) {
      const feControl = this.$document[0].querySelector(`.token-id-${this.token.id}.text-control`);
      this._maxWidth = feControl?.style.maxWidth;
      if (!this._maxWidth) {
        let parentElement = feControl.parentElement;
        while (parentElement) {
          const parentWidth = this.$window.getComputedStyle(parentElement).getPropertyValue('width');
          if (parentWidth && parentWidth !== 'auto' && parentWidth !== '0px') {
            this._maxWidth = parentWidth;
            break;
          }
          parentElement = parentElement.parentElement;
        }
      }
    }
    return this._maxWidth;
  }

  rendered() {
    super.rendered();
    if (this.isDynamic) this.$timeout(() => this.adjustDynamicWidth());
  }

  async initializeControlData() { // prefill has been loaded to model
    await super.initializeControlData();
    this.setReadOnlyHtml();
    if (!this.isPrint) this.$scope.$watch("$ctrl.enabled", _ => this.setReadOnlyHtml());
  }

  setReadOnlyHtml() {
    const htmlValue = this.FF.isDefined(this.model?.display) ? this.model.display : this.stdModel();
    const htmlString = this.FF.isDefined(htmlValue) ? htmlValue.toString() : '';
    this.readOnlyHtml = this.$sce.trustAsHtml(htmlString);
  }
  
  getMaxLength() {
    return this.token.control.maxLength;
  }

  valueChanged() {
    this.adjustDynamicWidth();
  }

  adjustDynamicWidth() {
    if (!this.isRendered || !this.baseOnInitDone || !this.isDynamic || this.isPrint || !this.visible) return;

    const feControl = this.$document[0].querySelector(`.token-id-${this.token.id}.text-control`);
    if (!feControl) return;

    const tempSpan = this.$document[0].createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.style.font = this.$window.getComputedStyle(feControl).font;
    tempSpan.textContent = this.model?.value || '';
    this.$document[0].body.appendChild(tempSpan);
    const newWidth = Math.ceil(tempSpan.offsetWidth * 1.01);
    this.$document[0].body.removeChild(tempSpan);

    feControl.style.width = `${(newWidth > this.initialWidth) ? newWidth: this.initialWidth}px`;
    feControl.style.maxWidth = this.maxWidth;
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/text-control/text-control.component.html",
  controller: TextControlCtrl
};
